module.exports = __webpack_public_path__ + "img/Combinationphoto1.6375de32.jpg";